import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { adobeAnalytics } from '@uhg-abyss/web/tools/event/listeners/adobeAnalytics';
import { qualtrics } from '@uhg-abyss/web/tools/event/listeners/qualtrics';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { storage } from '@uhg-abyss/web/tools/storage';
import { adobeTags } from './tags/adobe';
import { qualtricsTags } from './tags/qualtrics';
import { asyncMessagingTags } from './tags/asyncMessaging';
import { asyncMessaging } from '../asyncMessaging';
import { elasticApmAnalytics } from './elasticApm';
import { elasticApmTags } from './tags/elasticApm';

const maskAdobeClickTracking = () => {
  event.waitFor(
    () => {
      return window.s && window.s.ActivityMap;
    },
    () => {
      window.s.ActivityMap.link = () => null;
    }
  );
};

const SESSION_STORAGE_QUALTRICS_UUID = 'qualtrics_uuid';

export const ADOBE_ANALYTICS_ID = 'adobe-analytics-core';

export const registerAnalytics = (data) => {
  maskAdobeClickTracking();

  const adobeData = adobeAnalytics({
    id: 'adobe-analytics-core',
    enabled: config('ANALYTICS_TRACKING'),
    logging: config('ANALYTICS_LOGGING'),
    events: adobeTags,
    metadata: data,
  });

  const qualtricsData = qualtrics({
    id: 'qualtrics-core',
    url: config('QUALTRICS_SURVEY_SCRIPT'),
    logging: config('ANALYTICS_LOGGING'),
    enabled:
      storage.session.get(SESSION_STORAGE_QUALTRICS_UUID) !==
        config('GOLDEN_UUID') && getFeature('QUALTRICS_SURVEY'),
    events: qualtricsTags,
    metadata: data,
  });

  const asyncMessagingData = asyncMessaging({
    id: 'async-messaging-liveperson',
    enabled: getFeature('ASYNC_MESSAGING_LIVEPERSON'),
    logging: true,
    events: asyncMessagingTags,
    metadata: data,
  });

  const elasticApmData = elasticApmAnalytics({
    id: 'elastic-apm-core',
    name: 'sde-core',
    enabled: getFeature('CORE_ELASTIC_APM_TAGGING'),
    logging: getFeature('CORE_ELASTIC_APM_LOGGING'),
    events: elasticApmTags,
    metadata: data,
  });

  event.listener(qualtricsData);
  event.listener(adobeData);
  event.listener(asyncMessagingData);
  event.listener(elasticApmData);
};
